var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "atmo-hash-jump-point atmo-content-group",
      attrs: { id: "atmo-contract" },
    },
    [
      _c("h3", [_vm._v("Контракт")]),
      !_vm.pivc.isPurchaseOutATMO
        ? _c(
            "ul",
            {
              staticClass:
                "atmo-content-block-2-columns atmo-no-item-separator",
            },
            [
              this.$props.purchaseitem.plain.is_first_contract === false
                ? _c("li", { staticClass: "mb-2 pb-2" }, [
                    _c("dt", [_vm._v("Контракт со вторым местом. Причина:")]),
                    _c("dd", {
                      domProps: {
                        textContent: _vm._s(
                          this.$props.purchaseitem.plain
                            .first_contract_status_title
                        ),
                      },
                    }),
                  ])
                : _vm._e(),
              _c("li", { staticClass: "mb-2 pb-2" }, [
                _c("dt", [
                  _vm._v("Предмет контракта - наименование закупочной сессии:"),
                ]),
                _c("dd", {
                  domProps: {
                    textContent: _vm._s(this.$props.purchaseitem.description),
                  },
                }),
              ]),
              this.$props.purchaseitem.customer_contract_number
                ? _c("li", { staticClass: "mb-2 pb-2" }, [
                    _c("dt", [
                      _vm._v("Номер контракта в системе учета заказчика:"),
                    ]),
                    _c("dd", {
                      domProps: {
                        textContent: _vm._s(
                          this.$props.purchaseitem.customer_contract_number
                        ),
                      },
                    }),
                  ])
                : _vm._e(),
              this.$props.purchaseitem.contract.hasDeliveryCost()
                ? _c("li", { staticClass: "mb-2 pb-2" }, [
                    _c("dt", [_vm._v("Стоимость доставки, руб.:")]),
                    _c("dd", [
                      _vm._v(
                        _vm._s(
                          _vm._f("formatnumber")(
                            this.$props.purchaseitem.contract.delivery_cost
                          )
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _c("li", { staticClass: "mb-2 pb-2" }, [
                _c("dt", [_vm._v("Цена контракта, руб.:")]),
                _c("dd", [
                  _vm._v(
                    _vm._s(
                      _vm._f("formatnumber")(
                        this.$props.purchaseitem.contract.price_total
                      )
                    )
                  ),
                ]),
              ]),
              _c("li", { staticClass: "mb-2 pb-2" }, [
                _c("dt", [_vm._v("Статус контракта:")]),
                _c("dd", [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        this.$props.purchaseitem.contract
                          .acceptance_status_title
                      ),
                    },
                  }),
                ]),
              ]),
              _c("li", { staticClass: "mb-2 pb-2" }, [
                _c("dt", [_vm._v("Статус закупки:")]),
                _c("dd", {
                  domProps: {
                    textContent: _vm._s(this.$props.purchaseitem.status_title),
                  },
                }),
              ]),
            ]
          )
        : _vm._e(),
      _vm.pivc.isUserEngagedCustomer &&
      _vm.pivc.purchaseitem.allow_second_offer_contract
        ? _c("send-second-offer-contract", {
            attrs: { "purchase-item": _vm.pivc.purchaseitem.plain },
            on: { refresh: _vm.refresh },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }